import axios from 'axios';
import * as endpoints from '../constants/endpoints';

export function sendEmail(nameEmailMessage) {
  return axios.post(endpoints.SEND_EMAIL, nameEmailMessage);
}


// WEBPACK FOOTER //
// ./src/models/contact.js